import React, { ReactElement } from 'react'
import type { Dispatch } from 'redux'
import { useSelector } from 'react-redux'
import { Space, Breadcrumb } from 'antd'
import { HomeOutlined, BlockOutlined, LineChartOutlined } from '@ant-design/icons'
import type { RouterState } from 'connected-react-router'
import { useLocation } from 'react-router-dom'
// import { goBack } from 'connected-react-router'
import { IAppState } from '@/store/reducers'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
function PageBreadcrumb ({ routerParam, history, route, dispatch }: {
    routerParam: {
        path: string
        breadcrumbName: string
        icon?: string
    }[]
    dispatch: Dispatch
    history: any
    route?: RouterState
}): ReactElement {
    const location = useLocation()
    const { t } = useTranslation()
    
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)

    routerParam.splice(0, 1, {
        path: '/indexPage',
        breadcrumbName: t('indexPage'),
    })

    return (<Space className='router_nav' style={{ justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
            <Breadcrumb>
                {routerParam.map((routeItem, routeIndex) => {
                    const last = routeIndex === routerParam.length - 1
                    return (
                        <Breadcrumb.Item key={routeItem.path}>
                            {routeItem.icon === 'LineChartOutlined' && <LineChartOutlined />}
                            {
                                last ? (
                                    <span>{routeItem.breadcrumbName}</span>
                                ) : (
                                    <span className='ant-breadcrumb-link'
                                        style={{ cursor: 'pointer', color: '#333' }} 
                                        onClick={() => {
                                            if (routeIndex === 0) {
                                                history.replace('/indexPage')
                                            } else if (location.key && !location.pathname.includes('/techReviewAdd')) {
                                                history.goBack()
                                                // dispatch(goBack())
                                            } else {
                                                if (routeItem) {
                                                    history.replace(routeItem.path)
                                                } else {
                                                    history.replace('/indexPage')
                                                }
                                            }
                                        }}
                                    >
                                        <span className='anticon'>{routeIndex === 0 ? <HomeOutlined /> : <BlockOutlined />}</span>
                                        <span>{routeItem.breadcrumbName}</span>
                                    </span>
                                )
                            }
                        </Breadcrumb.Item>
                    )
                })}
            </Breadcrumb>
            <span style={{ display: 'block', cursor: 'pointer', fontSize: '16px', fontWeight: 500 }} 
                onClick={() => {
                    if (location.key) {
                        history.goBack()
                        // dispatch(goBack())
                    } else {
                        history.replace('/indexPage')
                    }
                }}>{t('return')}</span>
        </div>
        <div style={{ margin: '10px 10px 0 0' }}>{userInfo?.nickName || ''}</div>
    </Space>)
}

export default PageBreadcrumb
